import client from '../client'

export async function acceptOfferBySeller({ directOfferId }) {
  return client(`${process.env.NEXT_PUBLIC_LISTINGS_DOMAIN}/api/DirectOffers/AcceptOfferBySeller`, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ directOfferId }),
  })
}
